
<template>
  <div class="main">
    <div class="tip">
      <h1>
        <span />
        这个一个什么平台？
      </h1>
      <p>
        快转是一家以商家，店主等为服务对象，专业从事商铺转让出租的平台，为客户实现快速，便捷，有保障的服务目的。以专业的数据、强大的平台信息优势、特殊的营销渠道，帮助客户在短时间内快速实现商铺转让或出租等服务，帮用户免费找到合适的商铺，快转平台总部位于北京，于2012年策划组建团队，到现在近八年。公司在全国600多个城市开通了网点
      </p>
    </div>
    <div class="tip">
      <h1>
        <span />
        30天包转是真的吗？
      </h1>
      <p>
        是真的，平台郑重承诺30天内没有转（租）成功，平台全额退款。公司找店数据库资源庞大（通过云计算收集整理全网找店求租数据），系统智能筛选匹配，平台有实力做出这个承诺，这是是目前市场上少有敢做保证的平台。
      </p>
    </div>
    <div class="tip">
      <h1>
        <span />
        时间到了没有转（租）出，怎么退费？
      </h1>
      <p>
        如果在规定时间内未转出去，核实后退款的费用原路退回账户（当天即可退回到账）
      </p>
    </div>
    <div class="tip">
      <h1>
        <span />
        转（租）出后还有其他收费吗？
      </h1>
      <p>
        没有后期费用，快转平台只收取98元信息服务费用，无其他任何费用。
      </p>
    </div>
    <div class="tip">
      <h1>
        <span />
        信息发布后在哪里查看？
      </h1>
      <p>
        当信息发布成功后，平台会同步全网数据（58同城、赶集网、百姓网、安居客、百度、今日头条、新浪微博、微信等等）系统数据库会自动匹配筛选出符合店铺需求的意向找店用户，全程自动化操作，找店用户看中你店铺直接跟您对接，平台可协助回访对你商铺有意向的用户，协助洽谈等服务
      </p>
    </div>
    <div class="tip">
      <h1>
        <span />
        发布的信息需要修改怎么办？
      </h1>
      <p>
        发布成功后可直接修改也可以联系客服修改、完善、优化、包装信息
      </p>
    </div>
    <div class="tip">
      <h1>
        <span />
        你们找店资源从哪里来的？
      </h1>
      <p>
        本平台找店求租不收取任何费用，完全免费<br>
        1.通过云计算、区块链、云服务等全网收集采集找店求租信息<br>
        2.通过百度、微信、腾讯、360、今日头条等大平台投放广告宣传免费找店<br>
        3.通过各城市房产公司、行业协会、商会等收集找店求租信息<br>
        4.通过大量人工用扫街的方式，一家一家的拜访收集找店求租信息<br>
        5.通过资源共享，渠道合作的方式收集找店求租客户信息<br>
        6.通过问卷调查的形式来收集客户信息等等
      </p>
    </div>
    <div class="tip">
      <h1>
        <span />
        为什么人家收费几百上千，你们只收取98元？
      </h1>
      <p>
        现在大数据时代，信息整合也变得简单，以前公司依赖人工业务员去联系，人工场地各方面开支更高，现今5G技术更新，所有操作可以全智能化系统运营，方便快捷降低成本，提高效率。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  created() {
    const token = this.$store.getters.token
    const { code = '' } = this.$route.query
    if (!token) {
      if (!code) {
        location.href = this.$loginUrl(encodeURIComponent(location.href))
      } else {
        this.$store.dispatch('getLogin', code).then(token => {
          this.token = token
          this.getConfig()
        })
      }
    } else {
      this.getConfig()
    }
  },
  methods: {
    async getConfig() {
      await this.$store.dispatch('setConfig')
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  .tip {
    margin-bottom: 20px;
    background: #ffffff;
    padding: 30px;
    h1 {
      display: flex;
      margin-bottom: 18px;
      align-items: center;
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 800;
      color: rgba(51, 51, 51, 1);
      span {
        margin-right: 20px;
        width: 12px;
        height: 12px;
        background: rgba(253, 106, 66, 1);
        border-radius: 50%;
      }
    }
    p {
      padding-left: 32px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
      line-height: 40px;
    }
  }
}
</style>
